import { queryOptions, useQuery } from '@tanstack/react-query';

import { socialApi } from '../api/social-api';

import { socialKeys } from './social-keys';

/** One row per connected network; a disconnected network keeps its row as `revoked`. */
export function socialConnectionsQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: socialKeys.connections(storeId),
    queryFn: () => socialApi.connections(storeId),
  });
}

export function useSocialConnections(storeId: string) {
  return useQuery(socialConnectionsQueryOptions(storeId));
}
